'use client';

type JsonLdProps = {
  data: Record<string, string | number | boolean | null | undefined>;
};

export default function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
} 